module.exports = __webpack_public_path__ + "static/media/postgres.c38b353e.jpg";